import axios from './config/config-viva'

const defaultRoute = 'reports/'

export default {
  async getReceiptsPerYear(data_inicial, data_final) {
    const { data } = await axios.get(`${defaultRoute}receipts-per-year`, {
      params: {
        data_inicial,
        data_final
      },
    })

    return data
  },
  async exportStatusReportFromCustomers({ status, initialDate, finalDate, cidade, plano }) {
    const { data } = await axios.get(
      `${defaultRoute}export-customers-status-report`,
      {
        params: {
          status,
          initialDate,
          finalDate,
          cidade,
          plano
        },
      }
    )

    return data
  },
  async statusReportFromCustomers({
    status,
    initialDate,
    finalDate,
    currentPage,
    perPage,
    cidade,
    plano
  }) {
    const { data } = await axios.get(`${defaultRoute}customers-status-report`, {
      params: {
        status,
        initialDate,
        finalDate,
        currentPage,
        perPage,
        cidade,
        plano
      },
    })

    return data
  },
  async billingExportReport({
    unit,
    initialDate,
    finalDate,
    planId = null,
    consumedOrNotConsumed,
  }) {
    const { data } = await axios.get(`${defaultRoute}billing-export-report`, {
      params: {
        unit,
        initialDate,
        finalDate,
        planId,
        consumedOrNotConsumed,
      },
    })

    return data
  },
  chargeClients: (
    unidade,
    dataInicial,
    dataFinal,
    planId = null,
    consumedOrNotConsumed
  ) => {
    return axios.get(`${defaultRoute}cobranca`, {
      params: {
        unidade,
        data_inicial: dataInicial,
        data_final: dataFinal,
        planId,
        consumedOrNotConsumed,
      },
    })
  },
  chargeClientsPeriod: (dataInicial, dataFinal, qtde, cidade) => {
    return axios.get(`${defaultRoute}cobranca-periodo`, {
      params: {
        data_inicial: dataInicial,
        data_final: dataFinal,
        qtde: qtde,
        cidade: cidade
      },
    })
  },
  chargeClientsPeriodGeral: (dataInicial, dataFinal, qtde) => {
    return axios.get(`${defaultRoute}cobranca-periodo-geral`, {
      params: {
        data_inicial: dataInicial,
        data_final: dataFinal,
        qtde: qtde,
      },
    })
  },
  chargeDependents: (planoId) => {
    return axios.get(`${defaultRoute}rel-dependents${
      planoId ? '?planoId=' + planoId : ''
    }`)
  },
  novosPlans: (data_inicial, data_final, acao, vendedor, plano) => {
    return axios.get(
      `${defaultRoute}planos-novos-especificos?data_inicial=${data_inicial}&data_final=${data_final}${
        acao ? '&acao=' + acao : ''
      }${vendedor ? '&vendedor=' + vendedor : ''}${
        plano ? '&plano=' + plano : ''
      }`
    )
  },

  adesaoAndCarencia: (dataInicial, dataFinal, movimento, plano, cliente) => {
    return axios.get(
      `${defaultRoute}adesao-e-carencia?data_inicial=${dataInicial}&data_final=${dataFinal} ${
        movimento ? '&movimento=' + movimento : ''
      }${plano ? '&plano=' + plano : ''}${cliente ? '&cliente=' + cliente : ''}`
    )
  },

  geralCancellation: (data_inicial, data_final) => {
    return axios.get(
      `${defaultRoute}cancelamentos-gerais?data_final=${data_final}&data_inicial=${data_inicial}`
    )
  },
  plansCancel: (unidade, data_inicial, data_final) => {
    return axios.get(
      `${defaultRoute}cancelamento${unidade ? '?unidade=' + unidade : ''}${
        data_inicial ? '&data_inicial=' + data_inicial : ''
      }${data_final ? '&data_final=' + data_final : ''}`
    )
  },
  geralRenewal: (data_inicial, data_final) => {
    return axios.get(
      `${defaultRoute}renovacao-geral${
        data_final ? '?data_final=' + data_final : ''
      }${data_inicial ? '&data_inicial=' + data_inicial : ''}`
    )
  },
  specificRenewalByDate: (data_inicial, data_final) => {
    return axios.get(`${defaultRoute}renovacao-especifica?data_inicial=${data_inicial}&data_final=${data_final}`)
  },
  specificRenewal: (unidade, vendedor, periodo) => {
    let url = `${defaultRoute}renovacao-especifica`

    if (unidade) url = url + `?unidade=${unidade}`

    if (!unidade && vendedor) {
      url = url + `?vendedor=${vendedor}`
    } else if (unidade && vendedor) {
      url = url + `&vendedor=${vendedor}`
    }

    if (!unidade && !vendedor) url = url + `?periodo=${periodo}`
    else url = url + `&periodo=${periodo}`

    return axios.get(url)
  },
  geralClient: (unidade, revenda, consumo, status, plano) => {
    return axios.get(
      `${defaultRoute}clientes-geral?revenda=${revenda}&status=${status}${
        unidade ? '&unidade=' + unidade : ''
      }${consumo ? '&consumo=' + consumo : ''}${
        status ? '&status=' + status : ''
      }${plano ? '&plano=' + plano : ''}`
    )
  },
  todayClient: (unidade, plano, data_inicial, data_final) => {
    return axios.get(
      `${defaultRoute}clientes-em-dia?data_inicial=${data_inicial}${
        plano ? '&plano=' + plano : ''
      }${unidade ? '&unidade=' + unidade : ''}`
    )
  },
  receipt: (nf, data_inicial, data_final) => {
    return axios.get(
      `${defaultRoute}nota-fiscal${
        data_inicial ? '?data_inicial=' + data_inicial : ''
      }${
        data_final ? '&data_final=' + data_final : ''
      }&tipo=mensalidade&nf=${nf}`
    )
  },
  receiptProcedimento: (nf, data_inicial, data_final, conveniado=null) => {
    return axios.get(
      `${defaultRoute}nota-fiscal${
        data_inicial ? '?data_inicial=' + data_inicial : ''
      }${
        data_final ? '&data_final=' + data_final : ''
      }&tipo=procedimento&nf=${nf}${
        conveniado ? '&conveniado=' + conveniado : ''
      }`
    )
  },
  inadimplencia: (data_inicial, data_final) => {
    return axios.get(
      `${defaultRoute}inadimplencia?data_inicial=${data_inicial}&data_final=${data_final}`
    )
  },
  taxaCarencia: (tipo, unidade, data_inicial, data_final) => {
    return axios.get(
      `${defaultRoute}taxa-de-carencia?tipo_de_carencia=${tipo}&data_inicial=${data_inicial}&data_final=${data_final}${
        unidade ? '&unidade=' + unidade : ''
      }`
    )
  },
  taxaCarenciaEspecifica: (tipo, plano, unidade, data_inicial, data_final) => {
    return axios.get(
      `${defaultRoute}taxa-de-carencia-especifica?tipo_de_carencia=${tipo}&data_inicial=${data_inicial}&data_final=${data_final}${
        plano ? '&plano=' + plano : ''
      }${unidade ? '&unidade=' + unidade : ''}`
    )
  },
  debitoAutomatico: (data_inicial, data_final) => {
    return axios.get(
      `${defaultRoute}debito-automatico?data_inicial=${data_inicial}&data_final=${data_final}`
    )
  },
  ausenciaConsulta: (conveniado, data_inicial, data_final) => {
    return axios.get(
      `${defaultRoute}ausencia-consulta?data_inicial=${data_inicial}&data_final=${data_final}${
        conveniado ? '&conveniado=' + conveniado : ''
      }`
    )
  },
  posConsulta: (conveniado, data_inicial, data_final, status) => {
    return axios.get(
      `${defaultRoute}pos-consulta?data_inicial=${data_inicial}&data_final=${data_final}&status=${status}${
        conveniado ? '&conveniado=' + conveniado : ''
      }`
    )
  },
  relatorioSubsidio(data_inicial, data_final, plano){
    return axios.get(
      `${defaultRoute}report-subsidio?data_inicial=${data_inicial}&data_final=${data_final}&planoId=${plano}`
    )
  },
  repostSubsidioSintetico(data_inicial, data_final){
    return axios.get(
      `${defaultRoute}report-subsidio-sintetico?data_inicial=${data_inicial}&data_final=${data_final}`
    )
  },
  repostSubsidioAnalitico(data_inicial, data_final){
    return axios.get(
      `${defaultRoute}report-subsidio-analitico?data_inicial=${data_inicial}&data_final=${data_final}`
    )
  },
  recebimentoPlanoConsulta(data_inicial, data_final){
    return axios.get(
      `${defaultRoute}recebimento-por-plano?data_inicial=${data_inicial}&data_final=${data_final}&isConsumo=true`
    )
  },
  consumoPlanoConsulta(data_inicial, data_final){
    return axios.get(
      `${defaultRoute}consumo-por-plano?data_inicial=${data_inicial}&data_final=${data_final}`
    )
  },
  pagamentosEmAberto: (data_inicial, data_final) => {
    return axios.get(
      `${defaultRoute}pagamentos-em-aberto?data_inicial=${data_inicial}&data_final=${data_final}`
    )
  },
  consumo: (ano) => {
    return axios.get(
      `${defaultRoute}report-consumo?ano=${ano}`
    )
  },
  aniversario: () => {
    return axios.get(
      `${defaultRoute}rel-birthdays`
    )
  },
}
